module.exports = __webpack_public_path__ + "img/star-mdi-filled.8cc40d83.svg";